// extracted by mini-css-extract-plugin
export default {"search":"style_search__fbu1U","clear":"style_clear__KyYI2"};